import { AnalyticPeriodsEnum } from '@workalizer/shared/enums';
import { averageTime, getInterval, groupByPeriod } from '@workalizer/shared/utils';
import { ensureValidWorkdayTimeRange, medianTime } from '@workalizer/shared/utils/workdayAlignment';
import { addDays, differenceInDays, endOfDay, format, startOfDay } from 'date-fns';
var generateMockWorkdayData = function (dateFrom, dateTo) {
    var startDate = new Date(dateFrom);
    var endDate = new Date(dateTo);
    var days = differenceInDays(endDate, startDate) + 1;
    return Array.from({ length: days }, function (_, i) {
        var currentDate = addDays(startDate, i);
        var dateStr = format(currentDate, 'yyyy-MM-dd');
        var userStartHour = 8 + (i % 3);
        var userEndHour = 16 + (i % 2);
        var teamStartHour = userStartHour - 1;
        var teamEndHour = userEndHour + 1;
        var createTime = function (hour) {
            return new Date("".concat(dateStr, "T").concat(hour.toString().padStart(2, '0'), ":00:00.000Z"));
        };
        return {
            date: dateStr,
            userData: {
                startWorkTime: createTime(userStartHour),
                endWorkTime: createTime(userEndHour)
            },
            teamData: {
                startWorkTime: createTime(teamStartHour),
                endWorkTime: createTime(teamEndHour)
            }
        };
    });
};
export var workdayAlignmentWithTeam = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo) === AnalyticPeriodsEnum.HOUR
        ? AnalyticPeriodsEnum.DAY
        : getInterval(input.dateFrom, input.dateTo);
    var mockWorkdayData = generateMockWorkdayData(input.dateFrom, input.dateTo);
    var workdayDataForGrouping = mockWorkdayData.map(function (day) { return ({
        date: day.date,
        items: [
            { type: 'user', data: day.userData },
            { type: 'team', data: day.teamData }
        ]
    }); });
    var periods = groupByPeriod(workdayDataForGrouping, startOfDay(new Date(input.dateFrom)), endOfDay(new Date(input.dateTo)), interval);
    return periods.map(function (period) {
        var _a;
        if (!((_a = period.items) === null || _a === void 0 ? void 0 : _a.length)) {
            return {
                period: period.date,
                startWorkTime: null,
                endWorkTime: null,
                teamAverageStartWorkTime: null,
                teamAverageEndWorkTime: null
            };
        }
        var allDayData = period.items.flat();
        var userDataForPeriod = allDayData
            .filter(function (item) { return item.type === 'user'; })
            .map(function (item) { return ({
            firstActivity: item.data.startWorkTime,
            lastActivity: item.data.endWorkTime
        }); });
        var teamDataForPeriod = allDayData
            .filter(function (item) { return item.type === 'team'; })
            .map(function (item) { return ({
            firstActivity: item.data.startWorkTime,
            lastActivity: item.data.endWorkTime
        }); });
        var teamTimes = ensureValidWorkdayTimeRange(medianTime(teamDataForPeriod, 'start'), medianTime(teamDataForPeriod, 'end'));
        return {
            period: period.date,
            startWorkTime: averageTime(userDataForPeriod, 'start'),
            endWorkTime: averageTime(userDataForPeriod, 'end'),
            teamAverageStartWorkTime: teamTimes.startTime,
            teamAverageEndWorkTime: teamTimes.endTime
        };
    });
};
